module.exports = __webpack_public_path__ + "static/img/ucm-sos-rescate-2.728019a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ucm-sos-rescate-2.png
// module id = G0kX
// module chunks = 1